export const SELF_SERVE_CX_CSM_ID = 196
export const ORDER_TRAINING_FORM_URL = "https://share.hsforms.com/1UbCxjTRvTwq804WnNql72A2qfyk"
